export default __webpack_public_path__ + "static/media/profile2.4efe0a4a.svg";